import src from "IMAGE";
export default { src, width: 144, height: 171, blurWidth: 0, blurHeight: 0};
